import { render, staticRenderFns } from "./CreateDataCenter.vue?vue&type=template&id=28171ca8&lang=pug"
import script from "./CreateDataCenter.vue?vue&type=script&lang=js"
export * from "./CreateDataCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28171ca8')) {
      api.createRecord('28171ca8', component.options)
    } else {
      api.reload('28171ca8', component.options)
    }
    module.hot.accept("./CreateDataCenter.vue?vue&type=template&id=28171ca8&lang=pug", function () {
      api.rerender('28171ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/datacenter/CreateDataCenter.vue"
export default component.exports